<template>
<div class="chapter">
<div class="inner_page">
<p class="CTA"><span epub:type="pagebreak" id="pageix" title="ix"></span>Contents</p>
<p class="CFMH" id="cover"><span epub:type="pagebreak" id="pagex" title="x"></span><a href="#/Text/Cover"><span class="blue">Cover</span></a></p>
<p class="CFMH" id="title"><a href="#/Text/Titlepage"><span class="blue">Title Page</span></a></p>
<p class="CFMH" id="ded"><a href="#/Text/Dedication"><span class="blue">Dedication</span></a></p>
<p class="CFMH" id="epi"><a href="#/Text/Epigraph"><span class="blue">Epigraph</span></a></p>
<p class="CFMH2" id="fore"><a href="#/Text/Foreword"><span class="blue">Foreword: This Scept’red Aisle</span></a></p>
<p class="CCT" id="chap01"><a href="#/Text/Ch01"><span class="blue">Childe Harry</span></a></p>
<p class="CCT" id="chap02"><span href="#/Text/Ch02" title="Link target outside of Sample"><span class="blue">Hollywood Royalty</span></span></p>
<p class="CCT" id="chap03"><span href="#/Text/Ch03" title="Link target outside of Sample"><span class="blue">Goodbye, Mummy</span></span></p>
<p class="CCT" id="chap04"><span href="#/Text/Ch04" title="Link target outside of Sample"><span class="blue">[You Gotta Have] Heart</span></span></p>
<p class="CCT" id="chap05"><span href="#/Text/Ch05" title="Link target outside of Sample"><span class="blue">The Playing Fields of Eton: Acting Out</span></span></p>
<p class="CCT" id="chap06"><span href="#/Text/Ch06" title="Link target outside of Sample"><span class="blue">Fitting in a Box: Acting</span></span></p>
<p class="CCT" id="chap07"><span href="#/Text/Ch07" title="Link target outside of Sample"><span class="blue">Attention Must Be Paid: Growing Up</span></span></p>
<p class="CCT" id="chap08"><span href="#/Text/Ch08" title="Link target outside of Sample"><span class="blue">Uniforms: You’re in the Army Now</span></span></p>
<p class="CCT" id="chap09"><span href="#/Text/Ch09" title="Link target outside of Sample"><span class="blue">Moving On and Moving Out: <span class="ital">Suits</span> and Charities Abroad</span></span></p>
<p class="CCT" id="chap10"><span href="#/Text/Ch10" title="Link target outside of Sample"><span class="blue">Charities Begin at Home</span></span></p>
<p class="CCT" id="chap11"><span href="#/Text/Ch11" title="Link target outside of Sample"><span class="blue">When Harry Met Meghan</span></span></p>
<p class="CCT" id="chap12"><span href="#/Text/Ch12" title="Link target outside of Sample"><span class="blue">Harry Hitches His Wagon to a Star</span></span></p>
<p class="CCT" id="chap13"><span href="#/Text/Ch13" title="Link target outside of Sample"><span class="blue">American Princess</span></span></p>
<p class="CBMHF" id="ack"><span href="#/Text/Acknowledgments" title="Link target outside of Sample"><span class="blue">Acknowledgments</span></span></p>
<p class="CBMH" id="bib"><span href="#/Text/Bibliography" title="Link target outside of Sample"><span class="blue">Selected Bibliography</span></span></p>
<p class="CBMH" id="ata"><span href="#/Text/ATA" title="Link target outside of Sample"><span class="blue">About the Author</span></span></p>
<p class="CBMH" id="copy"><span href="#/Text/Copyright" title="Link target outside of Sample"><span class="blue">Copyright</span></span></p>
<p class="CBMH" id="atp"><span href="#/Text/ATP" title="Link target outside of Sample"><span class="blue">About the Publisher</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?20f7ae49